export { default } from "./CustomResourceLink";
